
<template>
  <div class="bg-white">
    <div class="relative pb-10">
      <div>
        <div class="relative">
          <div class="absolute inset-0">
            <img class="w-full h-full object-cover" src="https://pslive.blob.core.windows.net/images/11-11/11-11-thumb.jpg" alt="" />
            <div class="absolute inset-0" aria-hidden="true" style="background-image: linear-gradient(to left bottom, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8))" />
          </div>
          <div class="relative max-w-7xl mx-auto md:p-6">
            <div class="max-w-3xl mx-auto">
              <div>
                <img src="https://pslive.blob.core.windows.net/images/11-11/11-11-thumb.jpg" alt="" class="md:rounded-xl">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="relative z-50 flex-none border-b py-2">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-wrap items-center justify-center lg:flex-nowrap">
          <div class="flex space-x-2 md:space-x-4">
            <a class="inline-flex justify-center rounded-xl bg-black py-4 px-6 md:py-4 md:px-6 text-sm md:text-base font-semibold text-white hover:bg-gray-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500" href="https://forms.monday.com/forms/e5faf8148353beb2a5c58245e37c3da3?r=euc1&project_id=11_11_fast" target="_blank">
              Sign Up
            </a>
          </div>
        </div>
      </div>

      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" id="info-panel">
        <!-- <img class="mb-20 rounded-xl" src="/img/prayer-storm-conference-2025-1920x1080.jpg" /> -->

        <h1 class="mt-10 lg:mt-15 font-display text-4xl font-bold tracking-tighter text-gray-900 sm:text-6xl">
          11:11 Fast
        </h1>
        <div class="mt-6 space-y-6 font-display text-2xl tracking-tight text-gray-600">
          <p>Join us as Prayer Storm and christians from around the world fast and pray for 40 days for muslims to encounter Jesus! Watch the video below and sign up to receive updates throughout!</p>
        </div>
        <dl class="mt-10 grid md:grid-cols-2 gap-x-10 gap-y-4 md:auto-cols-auto md:grid-flow-col md:grid-cols-none md:justify-start text-left">
          <div>
            <dt class="font-mono text-sm text-gray-600">When</dt>
            <dd class="mt-0.5 text-2xl font-semibold tracking-tight text-gray-900">17 Feb - 28 Mar, 2026</dd>
          </div>
          <div>
            <dt class="font-mono text-sm text-gray-600">Where</dt>
            <dd class="mt-0.5 text-2xl font-semibold tracking-tight text-gray-900">At Home + Online</dd>
          </div>
        </dl>
      </div>
    </div>

    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="text-center">
        <div class="mx-auto max-w-3xl rounded-xl bg-black p-4 text-lg font-semibold text-white focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500">
          <div class="video-container rounded-xl overflow-hidden">
            <iframe src="https://www.youtube-nocookie.com/embed/CX17EFaZzhg?si=E3FMQ4zBj4m6xEJm&amp;controls=0&amp;rel=0&amp;enablejsapi=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen class="w-full"></iframe>
          </div>
        </div>
      </div>
      <div class="py-10 text-center">
        <a class="mx-auto max-w-xl block rounded-xl bg-black p-4 text-lg font-semibold text-white hover:bg-gray-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500" href="https://forms.monday.com/forms/e5faf8148353beb2a5c58245e37c3da3?r=euc1&project_id=11_11_fast" target="_blank">
          <span class="inline">Sign Up</span>
        </a>
      </div>

      <div class="pb-10">
        <div class="mx-auto max-w-3xl rounded-2xl bg-gray-900 p-6 text-center text-white md:p-8">
          <p class="font-mono text-xs uppercase tracking-[0.2em] text-gray-300">Key Resource</p>
          <h2 class="mt-3 font-display text-2xl font-bold tracking-tight md:text-3xl">Scripture Prayer Focus Guide</h2>
          <p class="mt-3 text-gray-100">Use this as your main prayer focus guide throughout the 11:11 fast.</p>
          <router-link
            to="/11-11-fast/guide"
            class="mt-6 inline-flex items-center justify-center rounded-xl bg-white px-6 py-3 text-base font-semibold text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          >
            Open Guide
          </router-link>
        </div>
      </div>
    </div>

    <div class="mx-auto max-w-7xl px-4 pb-20 sm:px-6 lg:px-8">
      <div class="grid gap-12">
        <section class="rounded-2xl bg-gray-50 p-6 md:p-10">
          <div class="flex flex-col gap-4">
            <h2 class="font-display text-3xl font-bold tracking-tight text-gray-900">Get Involved</h2>
            <p class="text-lg text-gray-600">Join the 11:11 fast with a clear, simple path forward.</p>
          </div>
          <div class="mt-8 grid gap-6 md:grid-cols-2">
            <div class="rounded-xl bg-white p-6 shadow-sm">
              <p class="font-mono text-xs uppercase tracking-wide text-gray-500">Step 1</p>
              <h3 class="mt-2 text-xl font-semibold text-gray-900">Sign Up</h3>
              <p class="mt-2 text-gray-600">To join millions from around the world and receive updates during the fast including prayer livestreams we’ll be hosting for you to join with.</p>
            </div>
            <div class="rounded-xl bg-white p-6 shadow-sm">
              <p class="font-mono text-xs uppercase tracking-wide text-gray-500">Step 2</p>
              <h3 class="mt-2 text-xl font-semibold text-gray-900">Choose Your Fast</h3>
              <p class="mt-2 text-gray-600">Join us in fasting from food for 40 days by choosing the type of food fast you wish to commit to.</p>
            </div>
            <div class="rounded-xl bg-white p-6 shadow-sm">
              <p class="font-mono text-xs uppercase tracking-wide text-gray-500">Step 3</p>
              <h3 class="mt-2 text-xl font-semibold text-gray-900">Prepare Well</h3>
              <p class="mt-2 text-gray-600">Check out the resources below on how you can enter this 11:11 fast well.</p>
            </div>
            <div class="rounded-xl bg-white p-6 shadow-sm">
              <p class="font-mono text-xs uppercase tracking-wide text-gray-500">Step 4</p>
              <h3 class="mt-2 text-xl font-semibold text-gray-900">Spread The Word</h3>
              <p class="mt-2 text-gray-600">We encourage you to share this with your friends, family &amp; churches to get involved too.</p>
            </div>
            <div class="rounded-xl bg-white p-6 shadow-sm md:col-span-2">
              <p class="font-mono text-xs uppercase tracking-wide text-gray-500">Step 5</p>
              <h3 class="mt-2 text-xl font-semibold text-gray-900">Stay Committed</h3>
              <p class="mt-2 text-gray-600">Watch out for email updates and news on our social media as we guide you through the fast. Let’s do this together!</p>
            </div>
          </div>
        </section>

        <section class="rounded-2xl border border-gray-200 p-6 md:p-10">
          <div class="flex flex-col gap-4">
            <h2 class="font-display text-3xl font-bold tracking-tight text-gray-900">Resources</h2>
            <p class="text-lg text-gray-600">Helpful teachings and prayer aids for the 11:11 fast.</p>
          </div>
          <div class="mt-8 grid gap-8 md:grid-cols-2">
            <div class="rounded-xl bg-gray-50 p-6">
              <h3 class="text-xl font-semibold text-gray-900">New to fasting?</h3>
              <ul class="mt-4 space-y-3 text-gray-600">
                <li><a class="text-blue font-bold" href="https://www.youtube.com/watch?v=Y4wH_B6T9SY&list=PLyG_tGRFemqLbSccfvkfCxTMPASkZOARa&index=4">How Do I Fast Effectively? | Prayer Basics 101 | James Aladiran</a></li>
                <li><a class="text-blue font-bold" href="https://www.youtube.com/watch?v=jjjViRneGnA&list=PLyG_tGRFemqLj_lj0ea6z1GMPEIZGDdrr&index=147">How to Fast - James Aladiran | Prayer Storm</a></li>
                <li><a class="text-blue font-bold" href="https://www.youtube.com/watch?v=NROzje9hGdQ&list=PLyG_tGRFemqJ1_23rYV78UtSoj_JfstWa&index=19">The Power Of Fasting - Feat. James Aladiran</a></li>
              </ul>
            </div>
            <div class="rounded-xl bg-gray-50 p-6">
              <h3 class="text-xl font-semibold text-gray-900">Prayer Aids</h3>
              <ul class="mt-4 space-y-3 text-gray-600">
                <li><a class="text-blue font-bold" href="https://youtu.be/CI-mm2sclyw?si=GgP9ErSO9oflcnrd">The Persecuted Church and Jihad | James Aladiran</a></li>
                <li><a class="text-blue font-bold" href="https://youtu.be/OZ_UtZvwDzk?si=Kke3O_kWKbqZc6qW">Britain Must Not Fall | James Aladiran</a></li>
                <li><a class="text-blue font-bold" href="https://www.youtube.com/watch?v=2oo8tvizyZA">Former Jihadist Encounters Jesus | An interview with Pastor Isa El-Buba</a></li>
              </ul>
            </div>
          </div>
        </section>

        <section class="rounded-2xl bg-gray-900 p-6 md:p-10 text-white">
          <div class="flex flex-col gap-4">
            <h2 class="font-display text-3xl font-bold tracking-tight">FAQ</h2>
            <p class="text-lg text-gray-100">Quick answers to common questions.</p>
          </div>
          <div class="mt-8 grid gap-6">
            <div class="rounded-xl bg-white/15 p-6">
              <h3 class="text-xl font-semibold">Can I join this fast from another nation?</h3>
              <p class="mt-3 text-gray-100">Yes you can sign up online and pray with millions worldwide. You will also be updated throughout via email and social media to help guide you through this fast.</p>
            </div>
            <div class="rounded-xl bg-white/15 p-6">
              <h3 class="text-xl font-semibold">What kind of fast will I be committing to?</h3>
              <p class="mt-3 text-gray-100">There is freedom to choose how you fast during this period. However we highly encourage you to fast from food in some way. Some examples include liquid fast, dry fast, partial fast, daniel fast etc.</p>
            </div>
            <div class="rounded-xl bg-white/15 p-6">
              <h3 class="text-xl font-semibold">Are there online prayer meetings to join with leading up and during this fast?</h3>
              <p class="mt-3 text-gray-100">Yes we will be guiding you through this fast through email updates, online prayer livestreams and encouragement via our social media. Through signing up and following us on social media, you receive opportunities to meet together with millions online to fast and pray.</p>
            </div>
          </div>
        </section>
      </div>
      <div class="py-10 text-center">
        <a class="mx-auto max-w-xl block rounded-xl bg-black p-4 text-lg font-semibold text-white hover:bg-gray-500 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500" href="https://forms.monday.com/forms/e5faf8148353beb2a5c58245e37c3da3?r=euc1&project_id=11_11_fast" target="_blank">
          <span class="inline">Sign Up</span>
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.video-container {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
}
.video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
}
</style>
